module.exports = __webpack_public_path__ + "static/media/nav-dashboard-active.966e3c36.svg";